<template>
  <b-row>
    <b-col class="pad__column pad__column--first" cols="12" lg="3">
      <pad-link :link="image_link" css_class="d-block h-100">
        <div
          class="pad__image"
          :style="'background-image:url('+ thumbnail_url +'), url(\'/assets/images/common/statics/room_placeholder.png\')'"
        >
          <span class="pad__image-corner"></span>
        </div>
      </pad-link>
    </b-col>
    <b-col class="pad__column pad__column--second" cols="12" lg="9">
      <div class="pad__wrap" :class="wrap_class">
        <slot></slot>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import PadLink from "@liveeps/components/blocks/pad-link.vue"

export default {
  name: "pad-frame",

  components: {
    'pad-link': PadLink,
  },

  props: {
    thumbnail_url: String,
    image_link: {
      type: Object,
      default: null,
    },
    wrap_class: {
      type: [String, Array, Object],
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>

  .pad {
    $this: &;

    &__column {

      &--first {
        @at-root #{$this}__wrap & {
          @include media-breakpoint-up(lg) {
            padding-left: 0;
          }
        }

        .custom-link {
          height: 100%;
        }
      }

      &--first, &--second {
        position: static !important;
      }
    }

    &__image {
      min-height: 300px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      border-radius: $border-radius-lg * 2;
      clip-path: polygon(0% 0%, 100% 0%, 100% 102%, 85% 84%, 0 84%);
      position: relative;
      z-index: 1;

      @include media-breakpoint-up(lg) {
        clip-path: polygon(0 0, 101% 0, 91% 23%, 91% 100%, 0% 101%);
        min-height: 100%;
      }

      // trick angolo smussato
      &-corner {
        width: 30px;
        height: 30px;
        overflow: hidden;
        position: absolute;
        left: 0;
        bottom: 16%;
        z-index: 1;
        transform: scaleX(-1);

        @include media-breakpoint-up(lg) {
          left: auto;
          right: 9%;
          bottom: 0;
          transform: scaleX(1);
        }

        &:before {
          content: "";
          width: 200%;
          height: 200%;
          position: absolute;
          border-radius: $border-radius-lg * 2;
          bottom: 0;
          right: 0;
          box-shadow: 50px 50px 0 0 $vb-body-bg;
        }
      }
    }

    &__wrap {
      background-color: $white;
      margin-top: -40px;
      padding: 15px 20px;
      border-radius: $border-radius-lg * 2;
      display: flex;
      flex-flow: column;

      @include media-breakpoint-up(lg) {
        margin-top: 0;
        margin-left: -40px;
        padding: 20px 60px 20px 20px;
        position: relative;
      }

      &--20 {
        @include media-breakpoint-up(lg){
          padding-right: 20px;
        }
      }
    }
  }

</style>
